import type { LabelProps } from '@launchpad-ui/components';
import { Dialog, DialogTrigger, IconButton, Label, Popover } from '@launchpad-ui/components';
import cx from 'clsx';

import styles from './InfoLabel.module.css';

export type InfoLabelProps = LabelProps & {
  label: React.ReactNode;
  dialogContent?: React.ReactNode;
  popoverClassName?: string;
  infoLabelClassName?: string;
  isRequired?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
};

export const InfoLabel = ({
  label,
  dialogContent,
  id,
  isRequired,
  popoverClassName,
  infoLabelClassName,
  ...props
}: InfoLabelProps) => {
  const labelProps = { ...props };
  delete labelProps.onOpenChange;

  return (
    <div className={cx(styles.infoLabel, infoLabelClassName)}>
      <Label htmlFor={id} className={styles.label} {...labelProps}>
        {label} {isRequired && <span className={styles.required}>*</span>}
      </Label>
      {dialogContent && (
        <DialogTrigger onOpenChange={props.onOpenChange}>
          <IconButton icon="info-circle-outline" size="small" aria-label={`${label} info`} variant="minimal" />
          <Popover placement="start" className={popoverClassName}>
            <Dialog>
              <div className={cx(styles.dialogContent, popoverClassName)}>{dialogContent}</div>
            </Dialog>
          </Popover>
        </DialogTrigger>
      )}
    </div>
  );
};
